define('salesInboxRouter',[
  'require',
  'exports',
  'module',
  'marionette',
  'app',
  'itemPagesNameMixin'
], function (require, exports, module, Marionette, App, ItemPagesNameMixin) {
  'use strict';

  var SalesInboxRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'sales-inbox': 'showList',
      'sales-inbox/stats': 'showStats',
      'sales-inbox/routing-rules': 'showRoutingRules',
      'sales-inbox/:secId': 'showDetail'
    }
  });

  var API = {
    showList: function () {
      require([
        'salesInboxListView',
        'contentShowController'
      ], function (ListView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new ListView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.SALES_INBOX);
        });
      });
    },

    showDetail: function (secId) {
      require([
        'salesInboxDetailView',
        'contentShowController'
      ], function (DetailView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new DetailView({ secId: secId });
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.SALES_INBOX);
        });
      });
    },

    showStats: function () {
      require([
        'salesInboxStatsView',
        'contentShowController'
      ], function (StatsView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new StatsView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.SALES_INBOX_STATS);
        });
      });
    },

    showRoutingRules: function () {
      require([
        'salesInboxRoutingRulesView',
        'contentShowController'
      ], function (RoutingRulesView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new RoutingRulesView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.SALES_INBOX_ROUTING);
        });
      });
    }
  };

  App.on('before:start', function () {
    new SalesInboxRouter({ controller: API });
  });

  module.exports = SalesInboxRouter;
});

